export default __webpack_public_path__ + "assets/img/Submit.22da1e81.svg";